import React from "react";
import "./FeeStructure.css";
import { useEffect } from "react";
function FeeStructure() {

   useEffect(() => {
        window.scrollTo(0, 0);
      }, []); 
      
  return (
    <div className="fee-container">
      <h2 className="fee-heading">Fee Structure</h2>
      <div className="fee-section">
        <h3 className="fee-subheading">School Fees</h3>
        <ul className="fee-list">
          <li>
            <strong>Pre KG:</strong> ₹8000
          </li>
          <li>
            <strong>LKG and UKG:</strong> ₹10,000
          </li>
          <li>
            <strong>1st to 5th Standard:</strong> ₹12,000
          </li>
          <li>
            <strong>6th to 8th Standard:</strong> ₹15,000
          </li>
        </ul>
      </div>
      <div className="fee-section">
        <h3 className="fee-subheading">Van Fees</h3>
        <ul className="fee-list">
          <li>
            <strong>Khajuri Local:</strong> ₹3500
          </li>
          <li>
            <strong>Rudrawadi:</strong> ₹5000
          </li>
          <li>
            <strong>Bableshwar:</strong> ₹4000
          </li>
          <li>
            <strong>Jawalaga (J):</strong> ₹4500
          </li>
          <li>
            <strong>Alanga:</strong> ₹6000
          </li>
          <li>
            <strong>Khandal:</strong> ₹6000
          </li>
        </ul>
      </div>
    </div>
  );
}

export default FeeStructure;
